module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择日期范围"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "alue-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.vdate),
      callback: function($$v) {
        _vm.vdate = $$v
      },
      expression: "vdate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportloading),
      expression: "exportloading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "销售统计",
      "name": "goods_count"
    }
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.allListData,
        "stripe": "",
        "border": "",
        "height": _vm.wheight - 230
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "order_id",
        "label": "订单号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "trade_id",
        "label": "交易号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "mobile",
        "label": "会员手机号"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "user_id",
        "label": "会员ID"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "create_date",
        "label": "时间"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "number",
        "label": "门店ID"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "distributor_name",
        "label": "门店名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "pay_type",
        "label": "支付方式"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_fee",
        "label": "订单总金额(不含运费)"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "freight_fee",
        "label": "运费"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "discount_fee",
        "label": "app优惠"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "isPush",
        "label": "推送药关爱"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.isPush == 0) ? _c('span', [_vm._v("否")]) : _c('span', [_vm._v("是")])]
        }
      }], null, false, 2078839169)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "total_fee",
        "label": "订单总金额(含运费)"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4048a5cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4048a5cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/datacube/financedata.vue
// module id = 2661
// module chunks = 0